module.exports = "/_next/static/images/game-1-phone-attachment-park-730496aaa4797ba518cb919d19d06b1b.jpg";